import * as React from 'react'
import * as PropTypes from 'prop-types'
import styled from 'styled-components'

import ActionButton from '../../ui/ActionButton/ActionButton'
import AvatarUpload from '../../ui/AvatarUpload/AvatarUpload'

const AvatarWrapper = styled.div`
  text-align: center;
`

const ButtonWrapper = styled.div`
  margin: 1rem 0 0;
`

const BlockButton = styled(ActionButton)`
  width: 100%;
`

function DisplayPhotoForm(props) {
  const {
    handleSubmit,
    handleChange,
    values,
    isSubmitting,
    isValid,
    disabled,
    method,
    action,
    submitLabel,
    onAvatarUpload,
    onAvatarCrop,
    showSubmitButton = true,
    showDefaultAvatar = true,
  } = props

  return (
    <form onSubmit={handleSubmit} method={method} action={action}>
      <fieldset disabled={isSubmitting || disabled}>
        <AvatarWrapper>
          <AvatarUpload
            name="displayPhoto"
            label="Replace Photo"
            initialValue={values.avatarUrl}
            onChange={handleChange}
            onAvatarUpload={onAvatarUpload}
            onAvatarCrop={onAvatarCrop}
            showDefaultAvatar={showDefaultAvatar}
          />
        </AvatarWrapper>
        {!!showSubmitButton && (
          <ButtonWrapper>
            <BlockButton type="submit" variant="primary" disabled={!isValid}>
              {submitLabel || 'Next'}
            </BlockButton>
          </ButtonWrapper>
        )}
      </fieldset>
    </form>
  )
}

DisplayPhotoForm.defaultProps = {
  handleSubmit: null,
  handleChange: null,
  values: {},
  isSubmitting: false,
  isValid: false,
  disabled: false,
  method: 'get',
  action: '',
}

DisplayPhotoForm.propTypes = {
  handleSubmit: PropTypes.func,
  handleChange: PropTypes.func,
  values: PropTypes.shape(),
  isSubmitting: PropTypes.bool,
  isValid: PropTypes.bool,
  disabled: PropTypes.bool,
  method: PropTypes.string,
  action: PropTypes.string,
}

export default DisplayPhotoForm
